/**
 * NOTE: CODEGEN IS USED IN THIS FILE. Careless manual edits may be lost.
 *
 * server/tools/syncDirs.ts keeps this file in sync with:
 *   server/src/shared/UserRole.ts
 */

import {Type, Static} from "@sinclair/typebox";

/**
 * This is not necessarily a comprehensive list of all the roles, let alone all
 * the roles we use or will use. We should probably add them as they become relevant.
 *
 * Maybe.
 *
 * idk how to handle this
 */
export const USER_ROLE_MAP = {
	/** Misleadingly named role which is granted to all users with any staff-exclusive role,
	 * 		such as instructors, front desks, directors, and HQ staff */
	OFFICE_STAFF: "officestaff",
	FULLTIME_STAFF: "fulltime_staff",
	ADMIN: "admin",
	INSTRUCTOR: "instructor",
	DIRECTOR: "director",
	STUDENT: "student",
	PARENT: "parent",
	PLATFORM_STUDENT: "platform_student",
	LIMITED: "limited_user",
	SUPERVISOR: "supervisor",
	PIPELINE: "pipeline",
	EMAILER: "emailer",
	TA: "ta",
	SUBSTITUTE_INSTRUCTOR: "substitute-instructor",
	FRONT_DESK: "front-desk",
} as const;

export const userRoleT = Type.Union([
	Type.Literal(USER_ROLE_MAP.OFFICE_STAFF),
	Type.Literal(USER_ROLE_MAP.FULLTIME_STAFF),
	Type.Literal(USER_ROLE_MAP.ADMIN),
	Type.Literal(USER_ROLE_MAP.INSTRUCTOR),
	Type.Literal(USER_ROLE_MAP.DIRECTOR),
	Type.Literal(USER_ROLE_MAP.STUDENT),
	Type.Literal(USER_ROLE_MAP.PARENT),
	Type.Literal(USER_ROLE_MAP.PLATFORM_STUDENT),
	Type.Literal(USER_ROLE_MAP.LIMITED),
	Type.Literal(USER_ROLE_MAP.SUPERVISOR),
	Type.Literal(USER_ROLE_MAP.PIPELINE),
	Type.Literal(USER_ROLE_MAP.EMAILER),
	Type.Literal(USER_ROLE_MAP.TA),
	Type.Literal(USER_ROLE_MAP.SUBSTITUTE_INSTRUCTOR),
	Type.Literal(USER_ROLE_MAP.FRONT_DESK),
]);

export type UserRole = Static<typeof userRoleT>;
